if (!customElements.get('wls-real-perks')) {
    class WLSRealPerks extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                slider: 'carousel',
                item: 'carousel-cell',
                navigation: {
                    prev: 'js-wls-real-perks-prev',
                    next: 'js-wls-real-perks-next',
                }
            };

            this.elements = {
                slider: this.querySelector(`.${this.classes.slider}`),
                items: this.querySelectorAll(`.${this.classes.item}`),
                navigation: {
                    prev: this.querySelector(`.${this.classes.navigation.prev}`),
                    next: this.querySelector(`.${this.classes.navigation.next}`),
                }
            };

            //this.resizeHandler = this.handleResize.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('resize', this.resizeHandler);
        }

        disconnectedCallback() {
            if (this.flickity) {
                this.flickity.destroy();
            }
            window.removeEventListener('resize', this.resizeHandler);
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
        }

        checkIfEmpty() {
            const sliderInner = this.elements.slider;
            if (!sliderInner || !sliderInner.children.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }

        init() {
            if (!this.shouldInitialize()) return;
            this.initializeFlickity();
        }

        shouldInitialize() {
            if (!this.elements.slider || !this.elements.items.length) return false;

            const width = window.innerWidth;
            const slidesCount = this.elements.items.length;

            if (width < 768 && slidesCount <= 1) return false;
            if (width >= 768 && width < 1024 && slidesCount <= 3) return false;
            if (width >= 1024 && slidesCount <= 5) return false;

            return true;
        }



        initializeFlickity() {
            const isDesktop = window.innerWidth >= 1024;
            this.flickity = new Flickity(this.elements.slider, {
                cellAlign: 'left',
                wrapAround: true,
                imagesLoaded: true,
                pageDots: isDesktop ? false : true,
                prevNextButtons: false,
            });

            // Navigation
            if (this.elements.navigation.prev) {
                this.elements.navigation.prev.addEventListener('click', () => {
                    this.flickity.previous();
                });
            }

            if (this.elements.navigation.next) {
                this.elements.navigation.next.addEventListener('click', () => {
                    this.flickity.next();
                });
            }
        }
    }
    window.customElements.define('wls-real-perks', WLSRealPerks);
}